import { Injectable, OnDestroy, inject } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild, Router } from "@angular/router";
import { AuthenticationService } from "@app/services/authentication.service";
import { LoggingService } from "@app/services/logging.service";
import { OktaOidcService } from "@modules/okta-login/services/okta-oidc.service";
import { AppSettings } from "app/app.settings";
import { Subject } from "rxjs";

@Injectable()
export class AuthGuard implements CanActivateChild, OnDestroy {
   log = inject(LoggingService);
   private appSettings = inject(AppSettings);
   private authService = inject(AuthenticationService);
   private oktaOidcService = inject(OktaOidcService);
   private router = inject(Router);

   private destroyed: Subject<void> = new Subject<void>();

   public canActivateChild(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
   ): boolean {
      // All login methods
      if (!this.authService.isAuthenticated) {
         this.log.info("User not authenticated, redirecting to login");

         if (this.appSettings.bypassOktaLogin) {
            this.router.navigate(["/modal-login"]);
            return false;
         }

         this.oktaOidcService.setState("redirectUrl", state.url);
         this.oktaOidcService.login();

         return false;
      }

      // Session
      if (this.authService.tokenIsExpired) {
         this.log.info("Token expired, logout and redirecting to login");

         this.authService.logout();
         location.href = "";

         return false;
      }

      // Origin login is only allowed to access domain pages
      if (
         this.authService.isOriginSsoAuthenticated &&
         !state.url.startsWith("/ng/domain")
      ) {
         return false;
      }

      return true;
   }

   public ngOnDestroy(): void {
      this.destroyed.next();
      this.destroyed.complete();
   }
}
